@if (!isRouterLink) {
	<a [target]="target" [href]="href">
		<ng-content *ngTemplateOutlet="contentTpl"></ng-content>
	</a>
}

@if (isRouterLink) {
	<a [target]="target" [routerLink]="href">
		<ng-content *ngTemplateOutlet="contentTpl"></ng-content>
	</a>
}

<ng-template #contentTpl><ng-content></ng-content></ng-template>
